import { useContext } from 'react';
import { UserContext } from '../components/auth/auth-context'; 
import { Permissions, hasPermission } from '../util/accessControl';
import { useSelectedBusiness } from '../redux/store';

export const usePermissions = () => {
    const userContext = useContext(UserContext);
    const providerUser = userContext.providerUser;
    const selectedBusiness = useSelectedBusiness();
    const businessStaffs = selectedBusiness?.businessStaffs;

    const currentLoginStaff = businessStaffs?.find(
        (staff) => Number(staff.id) === providerUser.staffId
    );

    const userPermissions = currentLoginStaff?.role?.permissions || []; 

    const checkPermission = (requiredPermission, resourceCreatorId = null) => {
        return hasPermission(
            userPermissions,
            requiredPermission,
            providerUser.staffId,
            resourceCreatorId,
            currentLoginStaff?.id
        );
    };

    // Commonly used permission checks
    const canEditBookingType = (creatorId) =>
        checkPermission(Permissions.BookingType.EDIT, creatorId);

    // Commonly used permission checks
    const canAddBookingType = (creatorId) =>
        checkPermission(Permissions.BookingType.ADD, creatorId);

    const canViewStaff = () =>
        checkPermission(Permissions.Staff.VIEW);

    const canEditBusiness = () =>
        checkPermission(Permissions.Business.EDIT);

    const canEditCalendar = (creatorId) =>
        checkPermission(Permissions.Calendar.EDIT, creatorId);

    return {
        checkPermission,
        canEditBookingType,
        canAddBookingType,
        canViewStaff,
        canEditBusiness,
        canEditCalendar,
        userPermissions,
        currentLoginStaff
    };
}; 